export default class SalesReport {
  sales: number = 0;
  salesThisMonthLastYear: number = 0;
  invoices: number = 0;
  monthlySales: {
    month: string;
    sales: number;
  }[] = [];
  purchases: number = 0;
  purchaseAmounts: number = 0;
  total: number = 0;
  purchasesTotal: number = 0;
  purchasesThisMonthLastYear: number = 0;
  monthlyPurchases: {
    month: string;
    amounts: number;
    profitability: number;
  }[] = [];
  arise: string = "";

  // 利益
  profit: number = 0;
  profitability: number = 0;
  totalProfit: number = 0;
  totalProfitability: number = 0;
}
